import React, { useState } from 'react'
import { MdArrowDropDown } from 'react-icons/md'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../../assets/biztrade_logo/logo.png'
import { homeUrl } from '../../../utils/api'
import classes from '../Sidebar/Sidebar.module.css'

export default function Sidebar({ sidebarItems }) {
    const location = useLocation()
    const [open, setOpen] = useState(false)

    const handleToggle = () => setOpen((prev) => !prev)
    const handleLinkClick = () => setOpen(false)

    return (
        <div className={classes.sidebar}>
            <Link to={homeUrl}>
                <div className={classes.logoDiv}>
                    <img src={logo} alt="Logo" />
                </div>
            </Link>

            <div>
                {sidebarItems.map((item, i) => (
                    <li key={i}>
                        {item.path === '/products' ? (
                            <>
                                <button
                                    className={open ? classes.btnActive : classes.btnInactive}
                                    onClick={handleToggle}
                                    aria-expanded={open}
                                    aria-controls="product-dropdown">
                                    <div className={classes.iconDiv}>{item.icon}</div>
                                    <div>
                                        <div className={classes.productText}>{item.text}</div>
                                        <MdArrowDropDown
                                            className={
                                                open ? `${classes.iconDropDown} ${classes.open}` : classes.iconDropDown
                                            }
                                        />
                                    </div>
                                </button>

                                {open && (
                                    <div id="product-dropdown" className={`${classes.dropDown} ${classes.open}`}>
                                        <Link to="/product-list" onClick={handleLinkClick}>
                                            Product List/Edit
                                        </Link>
                                        <Link to="/product-add" onClick={handleLinkClick}>
                                            Product Add
                                        </Link>
                                    </div>
                                )}
                            </>
                        ) : (
                            <Link to={item.path}>
                                <div className={location.pathname === item.path ? classes.active : classes.inactive}>
                                    <div className={classes.iconDiv}>{item.icon}</div>
                                    <div>{item.text}</div>
                                </div>
                            </Link>
                        )}
                    </li>
                ))}
            </div>
        </div>
    )
}
